import { render } from "./BannerSVG.vue?vue&type=template&id=44249804&scoped=true"
import script from "./BannerSVG.vue?vue&type=script&lang=js"
export * from "./BannerSVG.vue?vue&type=script&lang=js"

import "./BannerSVG.vue?vue&type=style&index=0&id=44249804&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44249804"]])

export default __exports__